import React from 'react';
import { Settings } from 'lucide-react';
import PolicySetting from './PolicySetting';
import AdminPageHeader from '../../frame/RightPanelHeader';

const SettingsManagement: React.FC = () => {
    return (
        <div className="h-full flex flex-col bg-white">
            <AdminPageHeader
                title="설정 관리"
                icon={Settings}
                subtitle="시스템 약관 및 정보 설정을 관리합니다"
            />

            <div className="flex-1 overflow-y-auto custom-scrollbar p-8 bg-slate-50/30">
                <div className="max-w-4xl mx-auto animate-in fade-in slide-in-from-bottom-2 duration-300">
                    <PolicySetting />
                </div>
            </div>
        </div>
    );
};

export default SettingsManagement;
